// src/pages/admin/Subcategories.jsx
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { medicineAPI } from '../../services/api';

const Form = ({ form, onChange, categories }) => (
  <>
    <div className="form-group">
      <label className="form-label required">Category</label>
      <select className="form-select" name="category_id" value={form.category_id || ''} onChange={onChange} required>
        <option value="">— Select Category —</option>
        {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
    </div>
    <div className="form-group">
      <label className="form-label required">Subcategory Name</label>
      <input className="form-input" name="name" value={form.name || ''} onChange={onChange} placeholder="e.g. Penicillins" required />
    </div>
    <div className="form-group">
      <label className="form-label">Description</label>
      <textarea className="form-textarea" name="description" value={form.description || ''} onChange={onChange} />
    </div>
  </>
);

export default function Subcategories() {
  const [categories, setCategories] = useState([]);
  const [filterCategory, setFilterCategory] = useState('');

  useEffect(() => { medicineAPI.getCategories().then(r => setCategories(r.data.data)); }, []);

  return (
    <AdminLayout title="Subcategories">
      <CrudPage
        title="Subcategories"
        subtitle="Subcategories linked to medicine categories"
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'category_name', label: 'Category' },
          { key: 'name', label: 'Subcategory Name' },
          { key: 'description', label: 'Description' },
        ]}
        fetchFn={medicineAPI.getSubcategories}
        createFn={medicineAPI.createSubcategory}
        updateFn={medicineAPI.updateSubcategory}
        deleteFn={medicineAPI.deleteSubcategory}
        FormComponent={Form}
        formDefault={{ category_id: '', name: '', description: '' }}
        extraProps={{ categories }}
        renderFilters={() => (
          <select className="form-select" style={{ maxWidth: 200, margin: 0 }}
            value={filterCategory} onChange={e => setFilterCategory(e.target.value)}>
            <option value="">All Categories</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        )}
        customFilter={row => filterCategory ? String(row.category_id) === filterCategory : true}
      />
    </AdminLayout>
  );
}
